/* Inspired by CHANGE add-on offer – see docs/features/change-addon-offer.md */
(function (root) {
  // PS-1U-12M-LIC (Photo Library), PS-1U-12M-BND (Easy Read Bundle), their 2- and
  // 3-year variants (24M, 36M – Trello 6134), and the old three-part PS-1U-12M, which
  // ps_shopify treats as LIC. Only the terms CHANGE has variants for: CHANGE must
  // match its plan's months, or it would run for longer or shorter than the plan.
  var ELIGIBLE_PLAN = /^PS-[1-9]\d*U-((12|24|36)M-(LIC|BND)|12M)$/;
  var CHANGE = /^PS-\d+U-\d+M-CHG$/;
  var SKIP_KEY = 'psChangeOfferSkipped';

  var ChangeOffer = {
    OFFER_URL: '/pages/add-change',

    // Set by layout/theme.liquid from the basket the page was rendered with,
    // and refreshed from /cart.js when the page comes back from the
    // back/forward cache.
    cartHasChange: !!root.psCartHasChange,

    // Set by layout/theme.liquid: true only when the store has an add-change
    // page on the page.add-change template. Without it the redirect is a 404.
    offerReady: !!root.psChangeOfferReady,

    // The account page's Inspired by CHANGE tile (card 5609). ps_shopify's
    // /valid says change_bank when the Library account holder bought the
    // add-on and the licence is valid, so teammates get it too. Until
    // ps_shopify returns the field, the tile stays hidden.
    showAccountTile: function (data) {
      return !!data && data.valid === true && data.change_bank === true;
    },

    // The "Find out about Inspired by CHANGE" tile in More apps: everyone
    // who can't use the collection, so never alongside the tile above. Until
    // ps_shopify returns change_bank it follows the customer's own Shopify tag
    // (hasChangeTag, from Liquid), which a teammate never carries.
    showAccountOffer: function (data, hasChangeTag) {
      if (data && typeof data.change_bank === 'boolean') return !ChangeOffer.showAccountTile(data);
      return !hasChangeTag;
    },

    isEligiblePlanSku: function (sku) {
      return typeof sku === 'string' && ELIGIBLE_PLAN.test(sku);
    },

    isChangeSku: function (sku) {
      return typeof sku === 'string' && CHANGE.test(sku);
    },

    shouldOfferAfterAdd: function (addedSku, skipped, cartHasChange) {
      return !skipped && !cartHasChange && ChangeOffer.isEligiblePlanSku(addedSku);
    },

    cartHasChangeIn: function (cart) {
      return !!(cart && cart.items && cart.items.some(function (item) { return ChangeOffer.isChangeSku(item.sku); }));
    },

    isSkipped: function () {
      try {
        return root.sessionStorage.getItem(SKIP_KEY) === '1';
      } catch (e) {
        return false;
      }
    },

    markSkipped: function () {
      try {
        root.sessionStorage.setItem(SKIP_KEY, '1');
      } catch (e) {}
    },

    // Called from the AJAX add-to-cart success handler in theme.js. With
    // CHANGE already in the basket the usual added notice shows instead.
    handleAdded: function (itemData) {
      if (!ChangeOffer.offerReady) return false;
      if (!itemData || !ChangeOffer.shouldOfferAfterAdd(itemData.sku, ChangeOffer.isSkipped(), ChangeOffer.cartHasChange)) return false;
      root.location.href = ChangeOffer.OFFER_URL;
      return true;
    },

    // handleAdded leaves the add button in theme.js's "Adding…" state. If the
    // customer comes Back from the offer page and the browser restores the
    // product page from its back/forward cache, put the forms right again.
    resetAddForms: function (doc) {
      var forms = doc.querySelectorAll('form.ajax-product-form.add-in-progress');
      Array.prototype.forEach.call(forms, function (form) {
        form.classList.remove('add-in-progress');
        Array.prototype.forEach.call(form.querySelectorAll('[type="submit"][disabled]'), function (button) {
          button.removeAttribute('disabled');
          // theme.js keeps the original label in jQuery data('previous-value')
          if (root.jQuery) {
            var $button = root.jQuery(button);
            var previous = $button.data('previous-value');
            if (previous) $button[$button.is('button') ? 'html' : 'val'](previous);
          }
        });
      });
    }
  };

  if (root.addEventListener && root.document) {
    root.addEventListener('pageshow', function (evt) {
      if (!evt.persisted) return;
      ChangeOffer.resetAddForms(root.document);
      // The basket may have changed since this page was cached
      if (root.fetch) {
        root.fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (response) { return response.json(); })
          .then(function (cart) { ChangeOffer.cartHasChange = ChangeOffer.cartHasChangeIn(cart); })
          .catch(function () {});
      }
    });
  }

  if (root.document) {
    root.document.addEventListener('click', function (evt) {
      var link = evt.target.closest && evt.target.closest('[data-change-offer-skip]');
      if (link) ChangeOffer.markSkipped();
    });
  }

  root.ChangeOffer = ChangeOffer;
  if (typeof module !== 'undefined' && module.exports) module.exports = ChangeOffer;
})(typeof window !== 'undefined' ? window : globalThis);
